module.exports = __webpack_public_path__ + "img/nt-active.7ae24760.png";